<app-theme></app-theme>

@if (loading) {
  <div fxLayout="column"
    fxLayoutAlign="center center"
    fxLayoutGap="16px"
    class="loading-screen">
    <mat-spinner color="primary"></mat-spinner>
    <div>Loading</div>
  </div>
}

@if (!loading) {
  <router-outlet></router-outlet>
}
